import { loadTranslations, setLocale, syncTranslationWithStore } from 'react-redux-i18n'
import { applyMiddleware, createStore } from 'redux'

import logger from 'redux-logger'
import promise from 'redux-promise-middleware'
import thunk from 'redux-thunk'

import reducer from './actions'
import locale from './locale'

const middleware = applyMiddleware(promise(), thunk, logger)
// const middleware = applyMiddleware(promise(), thunk)

const store = createStore(reducer, middleware)

syncTranslationWithStore(store)
store.dispatch(loadTranslations(locale))
store.dispatch(setLocale('en')) //to change locale

export default store



// WEBPACK FOOTER //
// ./src/app/store.js